import { IJackpotCasinoState } from '@GFTypes/index';

export const JACKPOT_CASINO_STATE_DEFAULTS: IJackpotCasinoState = {
    enabled: false,
    statusLevels: [],
    hitsLevels: []
};
